export function SET_LISTS({ commit }, [site_lists]) {
    commit('SAVE_LISTS', [site_lists])
}